// Installs the Rails CSRF token as a default header on an axios instance.
// Called once from application.jsx before createInertiaApp so all axios
// requests — including those made by Inertia's transport layer — carry the
// X-CSRF-Token header automatically.
//
// Extracting this to a dedicated module allows the 3 branches (meta present /
// absent / empty content) to be unit-tested in microseconds without the >10s
// re-import cost of application.jsx (which eagerly imports all 23+ page modules
// via import.meta.glob).

export function installCsrfHeader(doc, axiosInstance) {
  const csrf = doc.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
  if (csrf) {
    axiosInstance.defaults.headers.common['X-CSRF-Token'] = csrf
  }
}
